const c = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, o = globalThis, _ = "10.8.0";
function P() {
  return l(o), o;
}
function l(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || _, t[_] = t[_] || {};
}
function g(e, t, n = o) {
  const s = n.__SENTRY__ = n.__SENTRY__ || {}, i = s[_] = s[_] || {};
  return i[e] || (i[e] = t());
}
const M = "Sentry Logger ", v = {};
function R(e) {
  if (!("console" in o))
    return e();
  const t = o.console, n = {}, s = Object.keys(v);
  s.forEach((i) => {
    const r = v[i];
    n[i] = t[i], t[i] = r;
  });
  try {
    return e();
  } finally {
    s.forEach((i) => {
      t[i] = n[i];
    });
  }
}
function B() {
  m().enabled = !0;
}
function U() {
  m().enabled = !1;
}
function x() {
  return m().enabled;
}
function O(...e) {
  S("log", ...e);
}
function F(...e) {
  S("warn", ...e);
}
function Y(...e) {
  S("error", ...e);
}
function S(e, ...t) {
  c && x() && R(() => {
    o.console[e](`${M}[${e}]:`, ...t);
  });
}
function m() {
  return c ? g("loggerSettings", () => ({ enabled: !1 })) : { enabled: !1 };
}
const p = {
  /** Enable logging. */
  enable: B,
  /** Disable logging. */
  disable: U,
  /** Check if logging is enabled. */
  isEnabled: x,
  /** Log a message. */
  log: O,
  /** Log a warning. */
  warn: F,
  /** Log an error. */
  error: Y
}, $ = Object.prototype.toString;
function G(e, t) {
  return $.call(e) === `[object ${t}]`;
}
function j(e) {
  return G(e, "Object");
}
function K(e) {
  return !!(e != null && e.then && typeof e.then == "function");
}
function V(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function X(e, t, n) {
  try {
    Object.defineProperty(e, t, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0
    });
  } catch {
    c && p.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function H() {
  const e = o;
  return e.crypto || e.msCrypto;
}
function h(e = H()) {
  let t = () => Math.random() * 16;
  try {
    if (e != null && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e != null && e.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
const N = 1e3;
function T() {
  return Date.now() / N;
}
function J() {
  const { performance: e } = o;
  if (!(e != null && e.now) || !e.timeOrigin)
    return T;
  const t = e.timeOrigin;
  return () => (t + e.now()) / N;
}
let C;
function q() {
  return (C ?? (C = J()))();
}
function z(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), !e.did && !t.did && (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || q(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : h()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function A(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && Object.keys(t).length === 0)
    return e;
  const s = { ...e };
  for (const i in t)
    Object.prototype.hasOwnProperty.call(t, i) && (s[i] = A(s[i], t[i], n - 1));
  return s;
}
function I() {
  return h();
}
const f = "_sentrySpan";
function L(e, t) {
  t ? X(e, f, t) : delete e[f];
}
function w(e) {
  return e[f];
}
const Q = 100;
class a {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: I(),
      sampleRand: Math.random()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const t = new a();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, L(t, w(this)), t;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(t) {
    this._client = t;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(t) {
    this._lastEventId = t;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(t) {
    return this._user = t || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && z(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(t) {
    return this._tags = {
      ...this._tags,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(t) {
    return this._extra = {
      ...this._extra,
      ...t
    }, this._notifyScopeListeners(), this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, s = n instanceof a ? n.getScopeData() : j(n) ? t : void 0, { tags: i, extra: r, user: d, contexts: D, level: y, fingerprint: b = [], propagationContext: E } = s || {};
    return this._tags = { ...this._tags, ...i }, this._extra = { ...this._extra, ...r }, this._contexts = { ...this._contexts, ...D }, d && Object.keys(d).length && (this._user = d), y && (this._level = y), b.length && (this._fingerprint = b), E && (this._propagationContext = E), this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._session = void 0, L(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: I(), sampleRand: Math.random() }), this._notifyScopeListeners(), this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(t, n) {
    var r;
    const s = typeof n == "number" ? n : Q;
    if (s <= 0)
      return this;
    const i = {
      timestamp: T(),
      ...t,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: t.message ? V(t.message, 2048) : t.message
    };
    return this._breadcrumbs.push(i), this._breadcrumbs.length > s && (this._breadcrumbs = this._breadcrumbs.slice(-s), (r = this._client) == null || r.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: w(this)
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = A(this._sdkProcessingMetadata, t, 2), this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(t) {
    return this._propagationContext = t, this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(t, n) {
    const s = (n == null ? void 0 : n.event_id) || h();
    if (!this._client)
      return c && p.warn("No client configured on scope - will not capture exception!"), s;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(
      t,
      {
        originalException: t,
        syntheticException: i,
        ...n,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(t, n, s) {
    const i = (s == null ? void 0 : s.event_id) || h();
    if (!this._client)
      return c && p.warn("No client configured on scope - will not capture message!"), i;
    const r = new Error(t);
    return this._client.captureMessage(
      t,
      n,
      {
        originalException: t,
        syntheticException: r,
        ...s,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(t, n) {
    const s = (n == null ? void 0 : n.event_id) || h();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: s }, this), s) : (c && p.warn("No client configured on scope - will not capture event!"), s);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
function W() {
  return g("defaultCurrentScope", () => new a());
}
function Z() {
  return g("defaultIsolationScope", () => new a());
}
class tt {
  constructor(t, n) {
    let s;
    t ? s = t : s = new a();
    let i;
    n ? i = n : i = new a(), this._stack = [{ scope: s }], this._isolationScope = i;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(t) {
    const n = this._pushScope();
    let s;
    try {
      s = t(n);
    } catch (i) {
      throw this._popScope(), i;
    }
    return K(s) ? s.then(
      (i) => (this._popScope(), i),
      (i) => {
        throw this._popScope(), i;
      }
    ) : (this._popScope(), s);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: t
    }), t;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function u() {
  const e = P(), t = l(e);
  return t.stack = t.stack || new tt(W(), Z());
}
function et(e) {
  return u().withScope(e);
}
function nt(e, t) {
  const n = u();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function k(e) {
  return u().withScope(() => e(u().getIsolationScope()));
}
function st() {
  return {
    withIsolationScope: k,
    withScope: et,
    withSetScope: nt,
    withSetIsolationScope: (e, t) => k(t),
    getCurrentScope: () => u().getScope(),
    getIsolationScope: () => u().getIsolationScope()
  };
}
function it(e) {
  const t = l(e);
  return t.acs ? t.acs : st();
}
function rt() {
  const e = P();
  return it(e).getCurrentScope();
}
function ot(e) {
  if (e)
    return at(e) ? { captureContext: e } : ut(e) ? {
      captureContext: e
    } : e;
}
function at(e) {
  return e instanceof a || typeof e == "function";
}
const ct = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function ut(e) {
  return Object.keys(e).some((t) => ct.includes(t));
}
function _t(e, t) {
  return rt().captureException(e, ot(t));
}
export {
  _t as c
};
//# sourceMappingURL=exports-xpZYqD67.js.map
